import { Stack, Typography } from '@mui/material';
import { ReactComponent as TrendNegative } from '../../assets/trend-negative.svg';
import { ReactComponent as TrendPositive } from '../../assets/trend-positive.svg';
import { ModelRuns } from '../../types';

const ExecChangeRenderer = (rowData: ModelRuns) => {
  const numVal = Number(rowData.exec_time_change_rate) as any;
  const value = Number(
    numVal.toFixed(1) % 1 === 0 ? numVal.toFixed(0) : numVal.toFixed(1),
  );

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
      {value !== 0 && (value > 0 ? <TrendNegative /> : <TrendPositive />)}
      <Typography
        sx={{
          color:
            value === 0 ? undefined : value > 0 ? 'common.red' : 'common.green',
        }}
      >
        {Math.abs(value)}%
      </Typography>
    </Stack>
  );
};

export default ExecChangeRenderer;
